// AdminLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
// import PreloaderAdmin from '../../PreloaderAdmin';


const AdminLayout = () => {
  return (
    <>
      {/* <PreloaderAdmin/> */}
      {/* Add Admin Sidebar/Header here if needed */}
      <Outlet />
    </>
  );
};

export default AdminLayout;
